import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { aggregatedDataApi } from "./aggregatedData/api";
import { authApi } from "./auth/api";
import { branchApi } from "./branch/api";
import { clientsApi } from "./clients/api";
import { contentApi } from "./content/api";
import { contentEditorApi } from "./contentEditor/api";
import { filesApi } from "./files/api";
import { inviteTherapistsApi } from "./inviteTherapists/api";
import { inviteTokensApi } from "./inviteTokens/api";
import { organizationsApi } from "./organizations/api";
import { partnersApi } from "./partners/api";
import { projectsApi } from "./projects/api";
import { relaxationReportsApi } from "./relaxationReports/api";
import rootReducer from "./root-reducer";
import { usersApi } from "./users/api";

const middleWares: any = [
    authApi.middleware,
    usersApi.middleware,
    aggregatedDataApi.middleware,
    projectsApi.middleware,
    organizationsApi.middleware,
    partnersApi.middleware,
    inviteTokensApi.middleware,
    inviteTherapistsApi.middleware,
    clientsApi.middleware,
    filesApi.middleware,
    branchApi.middleware,
    contentEditorApi.middleware,
    contentApi.middleware,
    relaxationReportsApi.middleware,
];

export const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(...middleWares),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
